import { render, staticRenderFns } from "./GraduatesSingleInitialCapabilityGroup.vue?vue&type=template&id=b158050e&"
import script from "./GraduatesSingleInitialCapabilityGroup.vue?vue&type=script&lang=js&"
export * from "./GraduatesSingleInitialCapabilityGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports